import { Tabs } from "antd";
import { ContatoTypes } from "../types";
import { Control, UseFormRegister } from "react-hook-form";
import { FormModalContato } from "./FormModalContato";
import { EstoqueContato } from "./EstoqueContato";
import { MovimentosContato } from "./MovimentosContato";

interface TabsInfoProps {
  dataSourceContato?: ContatoTypes;
  inputDisabled?: boolean;
  register: UseFormRegister<any>
  ContatoId: number;
  control: Control<any>;
  setHaveMovToPrint: (setHaveMovToPrint: boolean) => void
}

export function TabsInfoContato({ dataSourceContato, inputDisabled, register, ContatoId, control, setHaveMovToPrint }: TabsInfoProps) {
  return (
    <Tabs
      className="mt-[-1rem] mb-4"
      items={[
        {
          label: "Info. Contato",
          key: '1',
          children: (
            <div className="w-[70rem] h-[30rem] flex justify-center">
              <FormModalContato
                register={register}
                disabled={inputDisabled}
                contato={dataSourceContato}
                control={control}
                formEdit
              />
            </div>
          )
        },
        {
          label: "Estoque",
          key: '2',
          children: (
            <EstoqueContato ContatoId={ContatoId} />
          )
        },
        {
          label: "Movimentos",
          key: '3',
          children: (
            <MovimentosContato 
              ContatoId={ContatoId} 
              Nome={dataSourceContato?.Nome}
              Sobrenome={dataSourceContato?.Sobrenome}
              setHaveMovToPrint={setHaveMovToPrint}
            />
          )
        }
      ]}
    />
  );
}
